export const TEXT = {
  APP_TITLE: "Recon Tool",
  COMPARE_TOOL: {
    HEADER: "Compare Tool",
    NO_DIFFERENCE: "No difference in compared data",
    DIFFERENCE_IN_DATA: "total difference in compared data",
    SCHEDULES_SENT_BY_ADSALES: "Schedules as sent by Ad Sales",
    SCHEDULES_SENT_TO_AMAGI: "Schedules finally sent to Amagi",
    ENABLE_PROMO_EVENTS: "Enable promo events",
  },
  COMMON: {
    CHANGE_SUBSCRIPTION: "Change Subscription",
    SHOW_ALL_DATA: "Show all data",
    SHOW_ONLY_DIFFERENT_DATA: "Show only different data",
    SCHEDULE_DATA: "Schedule Data",
    AMAGI_AS_RUNS: "Amagi as runs",
    ISCI: "ISCI",
    HIT_TIME: "Hit Time",
    DURATION: "Duration",
    ALLOC: "Alloc",
    EVENT_CODE: "Event Code",
    EVENT_TITLE: "Event Title",
    PRODUCT_TITLE: "Product Title",
    NO_DATA: "No data",
    NO_DATA_CONFIG: "No data available for this configuration.",
    ERROR: "Something went wrong. Please try again later.",
    NETWORK: "Network",
    BROADCAST_DATE: "Broadcast Date",
    SALES: "Sales",
    CLEAR: "Clear",
    APPLY: "Apply",
    FEED: "Feed",
    SCHEDULES: "Schedules",
    SALES_LEVEL_SCHEDULES: "Sales level schedules",
    O_CHANGE_SUBSCRIPTION: "Oops! Change the subscription!",
    BILLING_REF: "Billing Reference",
  },
  VALIDATIONS: {
    NETWORK: "Network is required",
    BROADCAST_DATE: "Broadcast Date is required",
    SALES: "Sales is required",
  },
  SIDEBAR_LABELS: {
    AS_RUNS: "View as runs",
    BIL: "Break in Logger",
    REPORTS: "Asrun reports",
    COMPARE_TOOL: "Asrun compare tool",
    SOUNDMOUSE: "SoundMouse",
    ADMIN: "Access control",
  },
};
